module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-0 ma-0 body-1 white--text"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-space-between"
  }, [_c('div', [_vm._v("Actual :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.summary.actual))])])]), _vm._v(" "), _c('div', {
    staticClass: "pl-1"
  }, _vm._l((_vm.summary.actualTasks), function(task, index) {
    return _c('div', {
      key: index,
      staticClass: "pa-0 ma-0"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-space-between"
    }, [_c('div', [_vm._v(_vm._s(task.title) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(task.value))])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d45fcdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/Timeline/Summary/MenuSummary.vue
// module id = 2024
// module chunks = 0